import React, { useEffect, useState } from "react";
import "../../Home.scss";
import "../AppSection/AppSection.scss"
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import DIContainer from "../../../../config/di.container";
import UtilService from "../../../../services/UtilService";
import DITYPES from "../../../../config/di.types";

const PUBLIC_URL = process.env.PUBLIC_URL;

const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1
    }
};

const utilService = DIContainer.get<UtilService>(DITYPES.UtilService);
const AppSection: React.FC = () => {
    const [isMobileView, setIsMobileView] = useState(utilService.checkIsMobileView);
    const [isIpadView, setIsIpadView] = useState(utilService.checkIsIpadView);
    const PARTNER_BASE_URL = process.env.REACT_APP_PARTNER_BASE_URL;

    const arrow = (onClick, alignLeft) => {
        return (
            <i tabIndex={0} onKeyDown={() => onClick()} className={`${alignLeft == true ? "arrow-left" : "arrow-right"}`}
                onClick={() => onClick()}></i>
        )
    }

    const handleResize = () => {
        setIsMobileView(utilService.checkIsMobileView());
        setIsIpadView(utilService.checkIsIpadView());
      }

    useEffect(()=>{
        window.addEventListener("resize", handleResize);
    })

    const CustomRightArrow = ({ onClick, ...rest }) => {
        const {
            onMove,
            carouselState: { currentSlide, deviceType }
        } = rest;

        return (
            arrow(onClick, false)
        )
    };

    const CustomleftArrow = ({ onClick, ...rest }) => {
        const {
            onMove,
            carouselState: { currentSlide, deviceType }
        } = rest;

        return (
            arrow(onClick, true)
        )
    };
    return (
        <div className="section app-section">
            <div className="app-section-child">
                <span className="txt-partner-store">Partner Store Apps</span>
                <div className="explore-div">Explore our various partner solutions to learn more about what
our customers want and need from the Mindbody partner ecosystem.</div>
               {!isMobileView && !isIpadView && <a id="btn-app-view-partner" href={`${PARTNER_BASE_URL}en-US/home`} className="w-button btn-big view-store-btn" target="_blank">View Partner Store</a>}                
            </div>
            <div className="app-section-child panda-child" tabIndex={-1}>
                <Carousel
                    infinite={true}
                    arrows={true}
                    customLeftArrow={<CustomleftArrow onClick />}
                    customRightArrow={<CustomRightArrow onClick />}
                    dotListClass="pos-slider"
                    containerClass="container"
                    renderDotsOutside={true}
                    responsive={responsive}
                    itemClass="d-flex align-items-center"
                    showDots>
                    <div className="slider-div slider-div-panda" tabIndex={-1}>
                        <div className="panda-logo-div">
                            <img alt="fitgrid icom" className="panda-logo fit-grid-logo-img" tabIndex={-1} width="100"></img>
                        </div>
                        <div className="d-flex align-items-center d-flex justify-content-center text-image">
                            <img alt="fitgrid text" className="panda-img fit-grid-text-img" tabIndex={-1} width="225"></img>
                        </div>
                    </div>
                    <div className="slider-div slider-div-panda" tabIndex={-1}>
                        <div className="panda-logo-div">
                            <img alt="panda flow icon" className="panda-logo panda-flow-logo-img" tabIndex={-1} width="100"></img>
                        </div>
                        <div className="d-flex align-items-center d-flex justify-content-center text-image">
                            <img alt="panda flow text" className="panda-img panda-flow-text-img" tabIndex={-1} width="225"></img>
                        </div>
                    </div>
                    <div className="slider-div slider-div-panda" tabIndex={-1}>
                        <div className="panda-logo-div">
                            <img alt="class pass logo" className="panda-logo class-pass-logo-img" tabIndex={-1} width="100"></img>
                        </div>
                        <div className="d-flex align-items-center d-flex justify-content-center text-image">
                            <img alt="class pass text" className="panda-img class-pass-img class-pass-text-img" tabIndex={-1} width="225"></img>
                        </div>
                    </div>
                </Carousel>
            </div>
            {(isMobileView || isIpadView) && <div className="view-partner-section"><a id="btn-app-view-partner" href={`${PARTNER_BASE_URL}en-US/home`} className="w-button btn-big view-store-btn" target="_blank">View Partner Store</a></div>}                
        </div>
    );
}

export default AppSection;